// extracted by mini-css-extract-plugin
export default {"divider":"manage-access-modal_divider__XTCWA","infoBox":"manage-access-modal_infoBox__hUqsX"};